import { loadStripe } from '@stripe/stripe-js';

let runtimeStripePromise;

async function fetchPublishableKey() {
  try {
    // Runtime fetch from Cloud Functions; ensures test vs live matches backend project
    const res = await fetch('https://us-central1-marketplace-5fd46.cloudfunctions.net/getStripeConfig', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error('Failed to load Stripe config');
    const data = await res.json();
    const key = data?.publishableKey || '';
    console.log('Stripe runtime key starts with:', key ? key.substring(0, 20) + '...' : 'undefined');
    return key;
  } catch (err) {
    // Fallback to build-time env if runtime fetch fails (keeps local/dev working)
    const fallback = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
    console.warn('[stripe] Falling back to build-time key');
    console.log('Stripe fallback key starts with:', fallback ? fallback.substring(0, 20) + '...' : 'undefined');
    return fallback;
  }
}

export const stripePromise = (async () => {
  if (!runtimeStripePromise) {
    const publishableKey = await fetchPublishableKey();
    runtimeStripePromise = loadStripe(publishableKey);
  }
  return runtimeStripePromise;
})();


// Stripe configuration for Elements (appearance only)
export const STRIPE_ELEMENTS_OPTIONS = {
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: '#C97B53',
      colorBackground: '#ffffff',
      colorText: '#222222',
      colorDanger: '#df1b41',
      fontFamily: 'Montserrat, sans-serif',
      borderRadius: '8px',
    },
  },
};

// Stripe configuration for Payment Intents
export const STRIPE_CONFIG = {
  mode: 'payment',
  currency: 'usd',
  paymentMethodTypes: ['card'],
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: '#C97B53',
      colorBackground: '#ffffff',
      colorText: '#222222',
      colorDanger: '#df1b41',
      fontFamily: 'Montserrat, sans-serif',
      borderRadius: '8px',
    },
  },
};

// Utility function to format currency
export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

// Utility function to convert dollars to cents for Stripe
export const dollarsToCents = (dollars) => {
  return Math.round(parseFloat(dollars) * 100);
};
